import { CMPR_INTERACT_EVENT, dispatchCmprEvent } from '@campact/camper/utils';

const eventAttributes = ['camperWebComponent', 'context', 'event', 'innerText', 'url', 'value'];

function writeToDataLayer(event) {
  const eventData = processInnerText(replaceUndefinedValuesWithEmptyString({
    ...defaultEventData(),
    ...extractEventDataFromObject(
      filterEmptyEventDataFromObject(event.detail || {}),
    ),
    ...extractEventDataFromObject(
      filterEmptyEventDataFromObject(
        filterEventDataFromDataset(event.target.dataset || {}),
      ),
    ),
  }));

  if (Object.values(eventData).every((value) => value === '')) return;
  if (import.meta.env.MODE === 'development') console.log('Pushing to dataLayer:', eventData);
  window.dataLayer?.push(eventData);
}

function defaultEventData() {
  return eventAttributes.reduce((acc, entry) => ({ ...acc, [entry]: '' }), {});
}

function extractEventDataFromObject(object) {
  return eventAttributes
    .reduce((acc, entry) => (entry in object && (acc[entry] = object[entry]), acc), {});
}

function filterEventDataFromDataset(dataset) {
  return {
    camperWebComponent: dataset?.analyticsCamperWebComponent,
    context: dataset?.analyticsContext,
    event: dataset?.analyticsEvent,
    innerText: dataset?.analyticsInnerText,
    url: dataset?.analyticsUrl,
    value: dataset?.analyticsValue,
  };
}

function extractIntegerFromString(string) {
  const match = string?.match(/^\d+$/);
  return match ? parseInt(match[0], 10) : null;
}

function filterEmptyEventDataFromObject(object) {
  return Object.fromEntries(
    Object.entries(object).filter(([, value]) => typeof value !== 'undefined' && value !== null && value !== ''),
  );
}

function replaceUndefinedValuesWithEmptyString(obj) {
  return Object.fromEntries(
    Object.entries(obj).map((entry) => [entry[0], entry[1] === 'undefined' ? '' : entry[1]]),
  );
}

function processInnerText(obj) {
  return {
    ...obj,
    innerText: extractIntegerFromString(obj.innerText) || obj.innerText.trim(),
  };
}

export function dispatchCmprInputFocus({ details = {}, target }) {
  dispatchCmprEvent(target, CMPR_INTERACT_EVENT, {
    camperWebComponent: 'cmpr-input',
    event: 'cmpr-input-focus',
    ...details,
  });
}

export function dispatchCmprRadioChange({ target }, value = '') {
  dispatchCmprEvent(target, CMPR_INTERACT_EVENT, {
    camperWebComponent: 'cmpr-radio',
    event: 'cmpr-radio-change',
    value: value,
  });
}

export function initPiwikWebAnalytics() {
  window.addEventListener(CMPR_INTERACT_EVENT, writeToDataLayer);
};
